import User from "@/models/server/User";
import { PageCacheProvider } from "@renta-apps/athenaeum-react-common";
import { PostAsync } from "@/types/PostAsync";
import GetEmployeesRequest from "@/models/server/requests/GetEmployeesRequest";
import { UserRoleGroup } from "@/models/Enums";

/**
 * {@link User} provider
 */
class UserProvider {
    public async getManagersAsync(
        sender: PostAsync<null, User[]>,
        showUserGroups: boolean = true,
    ): Promise<User[]> {
        const endpoint = `/api/workOrders/getManagers?showUserGroups=${showUserGroups}` as const;

        return await PageCacheProvider.getAsync(endpoint, () =>
            sender.postAsync(endpoint, null),
        );
    }

    public async getSalesPersonsAsync(
        sender: PostAsync<null, User[]>,
    ): Promise<User[]> {
        const endpoint = "/api/workOrders/getSalesPersons" as const;

        return await PageCacheProvider.getAsync(endpoint, () =>
            sender.postAsync(endpoint, null),
        );
    }

    public async getMountersAsync(
        sender: PostAsync<GetEmployeesRequest, User[]>,
        request: GetEmployeesRequest
    ): Promise<User[]> {
        const endpoint = "/api/workOrders/getMounters" as const;

        return await PageCacheProvider.getAsync(endpoint, () =>
            sender.postAsync(endpoint, request),
        );
    }

    public async getContactPersonsAsync(
        sender: PostAsync<string, User[]>,
        constructionSiteOrWarehouseId: string,
    ): Promise<User[]> {
        return await sender.postAsync(
            "/api/workOrders/getContactPersons",
            constructionSiteOrWarehouseId,
        );
    }

    public assignDefaultRoleIfMissing(persons: User[]): void {
        for (const person of persons) {
            if (person && person.role === null) {
                person.role = {
                    group: UserRoleGroup.Unknown,
                    roleName: "",
                    organizationContractId: "",
                    organizationContract: null,
                    externalId: "",
                    isUserRole: false,
                };
            }
        }
    }
}

/**
 * {@link UserProvider} singleton
 */
export default new UserProvider();
